// extracted by mini-css-extract-plugin
module.exports = {"post":"post_post__ofLtH","title":"post_title__rIF1P","byline":"post_byline__f7GCn"};